var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable no-unused-vars */
import { Button, Divider } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PubSub from 'pubsub-js';
import React, { useEffect, useRef, useState } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { AccordionWrapper } from '../../../commons/AccordionWrapper';
import { TopLabeledTextField } from '../../../commons/TopLabeledTextField';
import { convertToHourMin } from '../../../commons/utils/DateFormatter';
import { ButtonWrapper, CustomHelperText, InputWrapper, ItemList, Wrapper, } from './Sequence.Styles';
import { BasicConfig } from './components/BasicConfig';
import { FilteringAndSorting } from './components/FilteringAndSorting';
import { Pacing } from './components/Pacing';
import { SequenceWrapper } from './components/SequenceWraper';
import { SnackbarComponent } from '../../../commons';
export var Sequence = function (_a) {
    var values = _a.values, setFieldValue = _a.setFieldValue, errors = _a.errors, touched = _a.touched, campaigns = _a.campaigns, contactFilters = _a.contactFilters, phoneFilters = _a.phoneFilters, dialerDefaults = _a.dialerDefaults, contactSorting = _a.contactSorting, contactLists = _a.contactLists, campaign = _a.campaign, studioFlows = _a.studioFlows, isBeingEdited = _a.isBeingEdited, handleSequenceCallback = _a.handleSequenceCallback, skipModal = _a.skipModal, onCampaignChange = _a.onCampaignChange, callingMode = _a.callingMode, selectedSchedule = _a.selectedSchedule, sequenceIsBeingEdited = _a.sequenceIsBeingEdited, onMultipleValidation = _a.onMultipleValidation;
    var _b = useState(false), openSnack = _b[0], setOpenSnack = _b[1];
    var _c = useState(''), snackMessage = _c[0], setSnackMessage = _c[1];
    var _d = useState(values.sequences || []), sequences = _d[0], setSequences = _d[1];
    var _e = useState(''), sequenceName = _e[0], setSequenceName = _e[1];
    var _f = useState(false), basicConfigExpand = _f[0], setBasicConfigExpand = _f[1];
    var _g = useState(false), fNSExpand = _g[0], setFNSExpand = _g[1];
    var _h = useState(false), pacingExpand = _h[0], setPacingExpand = _h[1];
    var _j = useState(false), sequenceNameTouched = _j[0], setSequenceNameTouched = _j[1];
    var _k = useState(false), basicConfigError = _k[0], setBasicConfigError = _k[1];
    var _l = useState(false), fnSError = _l[0], setFnSError = _l[1];
    var _m = useState(false), pacingError = _m[0], setPacingError = _m[1];
    var _o = useState(null), editIndex = _o[0], setEditIdex = _o[1];
    var _p = React.useState({}), updateState = _p[1];
    var forceUpdate = React.useCallback(function () { return updateState({}); }, []);
    var basicConfigRef = useRef(undefined);
    var fnsRef = useRef(undefined);
    var pacingRef = useRef(undefined);
    var _q = useState(false), livePartyIsStudioFlow = _q[0], setLivePartyIsStudioFlow = _q[1];
    var _r = useState(false), answeringMachineIsStudioFlow = _r[0], setAnsweringMachineIsStudioFlow = _r[1];
    var _s = useState(false), openStudioFlowOverrideAlert = _s[0], setOpenStudioFlowOverrideAlert = _s[1];
    var _t = useState(false), isEdit = _t[0], setIsEdit = _t[1];
    useEffect(function () {
        if (!sequenceIsBeingEdited) {
            setIsEdit(false);
        }
    }, [sequenceIsBeingEdited]);
    useEffect(function () { }, [isEdit]);
    var _u = useState({
        InitialCpa: false,
        InitialPacingDuration: false,
        InitialPacingSamples: false,
        AbandonmentIncrement: false,
        AbaTargetRate: false,
        CpaModifier: false
    }), pacingErrors = _u[0], setPacingErrors = _u[1];
    var _v = useState({
        InitialCpa: '',
        InitialPacingDuration: '',
        InitialPacingSamples: '',
        AbandonmentIncrement: '',
        AbaTargetRate: '',
        CpaModifier: ''
    }), pacingHelperText = _v[0], setPacingHelperText = _v[1];
    useEffect(function () { }, [sequences]);
    var errorHandler = function (field, value) {
        var _a, _b, _c;
        var globals = dialerDefaults;
        var min = globals[field + "Min"];
        var max = globals[field + "Max"];
        if (value > max) {
            setPacingErrors(__assign(__assign({}, pacingErrors), (_a = {}, _a["" + field] = true, _a)));
            setHelperText(field, field.replace(/([A-Z])/g, ' $1').trim() + " must be less than " + max);
        }
        else if (value < min) {
            setPacingErrors(__assign(__assign({}, pacingErrors), (_b = {}, _b["" + field] = true, _b)));
            setHelperText(field, field
                .replace(/([A-Z])/g, ' $1')
                .trim() + " must be greater than " + min);
        }
        else {
            setPacingErrors(__assign(__assign({}, pacingErrors), (_c = {}, _c["" + field] = false, _c)));
            setHelperText(field, '');
        }
    };
    var setHelperText = function (field, helperText) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (field === 'InitialCpa') {
            if (helperText === '')
                setPacingHelperText(__assign(__assign({}, pacingHelperText), (_a = {}, _a["" + field] = '', _a)));
            else if (pacingHelperText.InitialCpa !== helperText)
                setPacingHelperText(__assign(__assign({}, pacingHelperText), (_b = {}, _b["" + field] = helperText, _b)));
        }
        else if (field === 'InitialPacingDuration') {
            if (helperText === '')
                setPacingHelperText(__assign(__assign({}, pacingHelperText), (_c = {}, _c["" + field] = '', _c)));
            else if (pacingHelperText.InitialPacingDuration !== helperText)
                setPacingHelperText(__assign(__assign({}, pacingHelperText), (_d = {}, _d["" + field] = helperText, _d)));
        }
        else if (field === 'InitialPacingSamples') {
            if (helperText === '')
                setPacingHelperText(__assign(__assign({}, pacingHelperText), (_e = {}, _e["" + field] = '', _e)));
            else if (pacingHelperText.InitialPacingSamples !== helperText)
                setPacingHelperText(__assign(__assign({}, pacingHelperText), (_f = {}, _f["" + field] = helperText, _f)));
        }
        else if (field === 'CpaModifier') {
            if (helperText === '')
                setPacingHelperText(__assign(__assign({}, pacingHelperText), (_g = {}, _g["" + field] = '', _g)));
            else if (pacingHelperText.CpaModifier !== helperText)
                setPacingHelperText(__assign(__assign({}, pacingHelperText), (_h = {}, _h["" + field] = helperText, _h)));
        }
        else if (field === 'AbaTargetRate') {
            if (helperText === '')
                setPacingHelperText(__assign(__assign({}, pacingHelperText), (_j = {}, _j["" + field] = '', _j)));
            else if (pacingHelperText.AbaTargetRate !== helperText)
                setPacingHelperText(__assign(__assign({}, pacingHelperText), (_k = {}, _k["" + field] = helperText, _k)));
        }
        else if (field === 'AbandonmentIncrement') {
            if (helperText === '')
                setPacingHelperText(__assign(__assign({}, pacingHelperText), (_l = {}, _l["" + field] = '', _l)));
            else if (pacingHelperText.AbandonmentIncrement !== helperText)
                setPacingHelperText(__assign(__assign({}, pacingHelperText), (_m = {}, _m["" + field] = helperText, _m)));
        }
    };
    var handleBasicConfigHandlers = function (type, isStudioFlow) {
        if (type === 'liveParty' && isStudioFlow === true)
            setLivePartyIsStudioFlow(true);
        else
            setLivePartyIsStudioFlow(false);
        if (type === 'answeringMachine' && isStudioFlow === true)
            setAnsweringMachineIsStudioFlow(true);
        else
            setAnsweringMachineIsStudioFlow(false);
    };
    var handleCloseAlert = function () { return setOpenStudioFlowOverrideAlert(false); };
    // Always check all sequences for studio flow handlers against the campaign's studio flow override value? If one passes check on a callback (campaign value changes or handler value changes), open modal
    useEffect(function () {
        var _a, _b;
        if (openStudioFlowOverrideAlert === false && !skipModal) {
            var campaignOverride = ((_a = campaign === null || campaign === void 0 ? void 0 : campaign.BaseConfig) === null || _a === void 0 ? void 0 : _a.StudioFlowOverride) != null &&
                ((_b = campaign === null || campaign === void 0 ? void 0 : campaign.BaseConfig) === null || _b === void 0 ? void 0 : _b.StudioFlowOverride) !== '';
            if (campaignOverride) {
                var sequencesWithStudioFlowHandlers = sequences.filter(function (seq) {
                    return seq.basicConfig.livePartyHandler === 'PASS_TO_CONTACT_FLOW' ||
                        seq.basicConfig.answeringMachineHandler === 'PASS_TO_CONTACT_FLOW';
                });
                if (sequencesWithStudioFlowHandlers.length > 0) {
                    setOpenStudioFlowOverrideAlert(true);
                }
            }
        }
        onCampaignChange();
    }, [campaign]);
    useEffect(function () {
        reset();
    }, [callingMode]);
    useEffect(function () {
        var _a, _b;
        if (openStudioFlowOverrideAlert === false) {
            var campaignOverride = ((_a = campaign === null || campaign === void 0 ? void 0 : campaign.BaseConfig) === null || _a === void 0 ? void 0 : _a.StudioFlowOverride) != null &&
                ((_b = campaign === null || campaign === void 0 ? void 0 : campaign.BaseConfig) === null || _b === void 0 ? void 0 : _b.StudioFlowOverride) !== '';
            if (campaignOverride) {
                if (livePartyIsStudioFlow || answeringMachineIsStudioFlow) {
                    setOpenStudioFlowOverrideAlert(true);
                }
            }
        }
    }, [livePartyIsStudioFlow, answeringMachineIsStudioFlow, campaign]);
    useEffect(function () {
        PubSub.subscribe('schedule_discard', function (topic, msg) {
            try {
                reset();
            }
            catch (_a) {
                console.log('error');
            }
        });
    }, []);
    useEffect(function () {
        if (callingMode === 'agentless' && sequences.length > 0) {
            var newSequences = sequences.map(function (seq) {
                delete seq.pacing;
                return seq;
            });
            setSequences(newSequences);
            setFieldValue('sequences', newSequences);
            // } else if (callingMode === 'power' && sequences.length > 0) {
            //   const newSequences = sequences.map((seq) => ({
            //     ...seq,
            //     pacing: { clearPacing: 'no' },
            //   }));
            //   setSequences(newSequences);
            //   setFieldValue('sequences', newSequences);
        }
    }, [callingMode]);
    useEffect(function () {
        setSequences(values.sequences);
    }, [values.sequences]);
    var onDragEnd = function (result) {
        var destination = result.destination, source = result.source;
        if (!destination) {
            return;
        }
        if (destination.droppableId === source.droppableId &&
            destination.index === source.index) {
            return;
        }
        if (destination.droppableId === source.droppableId) {
            var column = __spreadArrays(sequences);
            var item = column[source.index];
            column.splice(source.index, 1);
            column.splice(destination.index, 0, item);
            setSequences(column);
            setFieldValue('sequences', column);
        }
    };
    var handleAddSequence = function () {
        var basicConfig = basicConfigRef.current.getValues();
        var filteringAndSorting = fnsRef.current.getValues();
        var pacing;
        if (pacingRef.current)
            pacing = pacingRef.current.getValues();
        var filteringAndSortingError = false;
        var basicConfigError = false;
        var pacingError = false;
        setSequenceNameTouched(true);
        if (basicConfig.livePartyHandler === 'none' ||
            (basicConfig.livePartyHandler === 'PASS_TO_CONTACT_FLOW' &&
                basicConfig.livePartyContactFlow === 'none') ||
            basicConfig.answeringMachineHandler === 'none' ||
            (basicConfig.answeringMachineHandler === 'PASS_TO_CONTACT_FLOW' &&
                basicConfig.answeringMachineContactFlow === 'none') ||
            basicConfig.phones.length <= 0) {
            basicConfigError = true;
        }
        Object.keys(filteringAndSorting).forEach(function (key) {
            if (key === 'contactFilters' && filteringAndSorting[key].length <= 0) {
                filteringAndSortingError = true;
            }
        });
        if (pacingRef.current && pacing.clearPacing === 'yes') {
            if (pacing.initialCpaMode == 'none' ||
                pacing.abaCalculation == 'none' ||
                pacingErrors["InitialCpa"] === true ||
                pacingErrors["InitialPacingDuration"] === true ||
                pacingErrors["InitialPacingSamples"] === true ||
                pacingErrors["CpaModifier"] === true ||
                pacingErrors["AbandonmentIncrement"] === true ||
                pacingErrors["AbaTargetRate]"] === true) {
                pacingError = true;
            }
        }
        var sequence;
        if (sequenceName === '' ||
            basicConfigError ||
            filteringAndSortingError ||
            pacingError) {
            setBasicConfigError(basicConfigError);
            setFnSError(filteringAndSortingError);
            if (pacingRef.current)
                setPacingError(pacingError);
        }
        else if (pacingRef.current) {
            sequence = __assign({ sequenceName: sequenceName,
                basicConfig: basicConfig,
                filteringAndSorting: filteringAndSorting }, (values.campaign &&
                callingMode === 'power' &&
                pacing && {
                pacing: pacing
            }));
            var _sequences = __spreadArrays(sequences);
            _sequences.push(sequence);
            setSequences(_sequences);
            setFieldValue('sequences', _sequences);
            reset();
            forceUpdate();
        }
        else {
            sequence = {
                sequenceName: sequenceName,
                basicConfig: basicConfig,
                filteringAndSorting: filteringAndSorting
            };
            var _sequences = __spreadArrays(sequences);
            _sequences.push(sequence);
            setSequences(_sequences);
            setFieldValue('sequences', _sequences);
            reset();
            forceUpdate();
        }
    };
    var reset = function () {
        var basicConfigReset = basicConfigRef.current.reSet;
        var fnsReset = fnsRef.current.reSet;
        var pacingReset;
        if (pacingRef.current)
            pacingReset = pacingRef.current.reSet;
        setBasicConfigError(false);
        setFnSError(false);
        setPacingError(false);
        setPacingErrors({
            InitialCpa: false,
            InitialPacingDuration: false,
            InitialPacingSamples: false,
            AbandonmentIncrement: false,
            AbaTargetRate: false,
            CpaModifier: false
        });
        setPacingHelperText({
            InitialCpa: '',
            InitialPacingDuration: '',
            InitialPacingSamples: '',
            AbandonmentIncrement: '',
            AbaTargetRate: '',
            CpaModifier: ''
        });
        setSequenceNameTouched(false);
        basicConfigReset();
        fnsReset();
        if (pacingRef.current)
            pacingReset();
        setSequenceName('');
        setEditIdex(null);
        setBasicConfigExpand(false);
        setFNSExpand(false);
        setPacingExpand(false);
        handleSequenceCallback(false);
    };
    var handleDeleteSequence = function (index) {
        var _sequences = __spreadArrays(sequences);
        _sequences.splice(index, 1);
        setSequences(_sequences);
        setFieldValue('sequences', _sequences);
        forceUpdate();
    };
    var handleCopySequence = function (data) {
        var _sequences = __spreadArrays(sequences);
        _sequences.push(data);
        setSequences(_sequences);
        setFieldValue('sequences', _sequences);
        forceUpdate();
    };
    var handleEditSequence = function (index, data) {
        var basicConfigSet = function (basicConfigSetData) {
            return basicConfigRef.current.setData(basicConfigSetData);
        };
        var fnsSet = function (fnsData) {
            return fnsRef.current.setData(fnsData);
        };
        var pacingSet;
        if (pacingRef.current) {
            pacingSet = function (pacingSetData) {
                return pacingRef.current.setData(pacingSetData);
            };
        }
        setSequenceName(data.sequenceName);
        basicConfigSet(data.basicConfig);
        fnsSet(data.filteringAndSorting);
        if (data.pacing)
            pacingSet(data.pacing);
        setBasicConfigExpand(true);
        setFNSExpand(true);
        setPacingExpand(true);
        setIsEdit(true);
        setEditIdex(index);
    };
    var handleUpdateSequence = function () {
        var _a;
        var basicConfig = basicConfigRef.current.getValues();
        var filteringAndSorting = fnsRef.current.getValues();
        var pacing = (_a = pacingRef.current) === null || _a === void 0 ? void 0 : _a.getValues();
        var basicConfigError = false;
        var filteringAndSortingError = false;
        var pacingError = false;
        setSequenceNameTouched(true);
        if (basicConfig.livePartyHandler === 'none' ||
            (basicConfig.livePartyHandler === 'PASS_TO_CONTACT_FLOW' &&
                basicConfig.livePartyContactFlow === 'none') ||
            basicConfig.answeringMachineHandler === 'none' ||
            (basicConfig.answeringMachineHandler === 'PASS_TO_CONTACT_FLOW' &&
                basicConfig.answeringMachineContactFlow === 'none') ||
            basicConfig.phones.length <= 0) {
            basicConfigError = true;
        }
        Object.keys(filteringAndSorting).forEach(function (key) {
            if (key === 'contactFilters' && filteringAndSorting[key].length <= 0) {
                filteringAndSortingError = true;
            }
        });
        if (pacingRef.current && pacing.clearPacing === 'yes') {
            if (pacing.initialCpaMode == 'none' ||
                pacing.abaCalculation == 'none' ||
                pacingErrors["InitialCpa"] === true ||
                pacingErrors["InitialPacingDuration"] === true ||
                pacingErrors["InitialPacingSamples"] === true ||
                pacingErrors["CpaModifier"] === true ||
                pacingErrors["AbandonmentIncrement"] === true ||
                pacingErrors["AbaTargetRate]"] === true) {
                pacingError = true;
            }
        }
        var sequence;
        if (sequenceName === '' ||
            basicConfigError ||
            filteringAndSortingError ||
            pacingError) {
            setBasicConfigError(basicConfigError);
            setFnSError(filteringAndSortingError);
            if (pacingRef.current)
                setPacingError(pacingError);
        }
        else if (pacingRef.current) {
            sequence = __assign({ sequenceName: sequenceName,
                basicConfig: basicConfig,
                filteringAndSorting: filteringAndSorting }, (values.campaign &&
                callingMode === 'power' &&
                pacing && {
                pacing: pacing
            }));
            var _sequences = __spreadArrays(sequences);
            _sequences.splice(editIndex, 1, sequence);
            setSequences(_sequences);
            setFieldValue('sequences', _sequences);
            reset();
            forceUpdate();
        }
        else {
            sequence = {
                sequenceName: sequenceName,
                basicConfig: basicConfig,
                filteringAndSorting: filteringAndSorting
            };
            var _sequences = __spreadArrays(sequences);
            _sequences.splice(editIndex, 1, sequence);
            setSequences(_sequences);
            setFieldValue('sequences', _sequences);
            reset();
            forceUpdate();
        }
        handleSequenceCallback(false);
        setIsEdit(false);
    };
    var handleCancelUpdateSequence = function (index) {
        setIsEdit(false);
        reset();
    };
    var validateFilter = function () {
        var basicConfig = basicConfigRef.current.getValues();
        var filteringAndSorting = fnsRef.current.getValues();
        var contactFilters = filteringAndSorting.contactFilters.length > 0 ? filteringAndSorting.contactFilters.map(function (c) { return c.value; }) : [];
        var phoneFilters = filteringAndSorting.phoneFilters.length > 0 ? filteringAndSorting.phoneFilters.map(function (c) { return c.value; }) : [];
        var validationPayload = {
            campaignId: campaign.id,
            phones: basicConfig.phones,
            filterIds: __spreadArrays(contactFilters, phoneFilters),
            startTime: convertToHourMin(values.startTime),
            endTime: convertToHourMin(values.endTime),
            timezone: values.timeZone
        };
        if (validationPayload.campaignId) {
            onMultipleValidation(validationPayload);
        }
        else {
            setOpenSnack(true);
            setSnackMessage('No Campaign is selected!');
        }
    };
    var willError = !!errors.sequences && touched.sequences;
    return (React.createElement(Wrapper, null,
        React.createElement(DragDropContext, { onDragEnd: onDragEnd },
            React.createElement(Droppable, { droppableId: 'sequencesDropSite' }, function (provided) { return (React.createElement(ItemList, __assign({ innerRef: provided.innerRef }, provided.droppableProps),
                sequences.map(function (sequence, i) { return (React.createElement(SequenceWrapper, { onEdit: function (_index, data) { return handleEditSequence(_index, data); }, onCopy: function (data) { return handleCopySequence(data); }, onDelete: function (e) { return handleDeleteSequence(e); }, data: sequence, text: sequence.sequenceName, key: i, index: i, aSequenceIsBeingEdited: [isBeingEdited, editIndex], isBeingEdited: editIndex === i ? true : false, handleSequenceCallback: handleSequenceCallback, values: values })); }),
                provided.placeholder)); })),
        React.createElement(Divider, null),
        React.createElement(InputWrapper, null,
            React.createElement(TopLabeledTextField, { label: 'Sequence Name', value: sequenceName, onChange: function (e) { return setSequenceName(e.target.value); }, onBlur: function () { return setSequenceNameTouched(true); }, error: sequenceName === '' && sequenceNameTouched, helperText: sequenceName === '' &&
                    sequenceNameTouched &&
                    'This Field is Required' }),
            values.campaign && callingMode === 'power' && (React.createElement(React.Fragment, null,
                React.createElement(AccordionWrapper, { name: 'Pacing', expanded: pacingExpand, onChange: function (_, expanded) {
                        setPacingExpand(expanded);
                    } },
                    React.createElement(Pacing, { campaigns: campaigns, dialerDefaults: dialerDefaults, campaign: campaign, pacingErrors: pacingErrors, helperText: pacingHelperText, errorHandler: errorHandler, pacingExpanded: pacingExpand, selectedSchedule: selectedSchedule, isEdit: isEdit, ref: pacingRef })),
                pacingError && (React.createElement(CustomHelperText, { error: true }, "Some Fields are Incorrect")))),
            React.createElement(React.Fragment, null,
                React.createElement(AccordionWrapper, { name: 'Basic Config', expanded: basicConfigExpand, onChange: function (_, expanded) { return setBasicConfigExpand(expanded); } },
                    React.createElement(BasicConfig, { campaigns: campaigns, dialerDefaults: dialerDefaults, campaign: campaign, studioFlows: studioFlows, ref: basicConfigRef, handleBasicConfigHandlers: handleBasicConfigHandlers })),
                basicConfigError && (React.createElement(CustomHelperText, { error: true }, "Some Fields are Missing"))),
            React.createElement(React.Fragment, null,
                React.createElement(AccordionWrapper, { name: 'Filtering and Sorting', expanded: fNSExpand, onChange: function (_, expanded) { return setFNSExpand(expanded); } },
                    React.createElement(FilteringAndSorting, { ref: fnsRef, contactFilters: contactFilters, phoneFilters: phoneFilters, contactSorting: contactSorting, contactLists: contactLists, campaign: campaign, onValidateFilters: function () {
                            validateFilter();
                        } })),
                fnSError && (React.createElement(CustomHelperText, { error: true }, "Some Fields are Missing")))),
        sequences.length <= 0 && willError && (React.createElement(CustomHelperText, { error: willError }, errors.sequences)),
        React.createElement(ButtonWrapper, { className: 'form-buttons' }, editIndex == null ? (React.createElement(React.Fragment, null,
            React.createElement(Button, { variant: 'outlined', color: 'primary', onClick: function () { return handleAddSequence(); } }, "Add Sequence"),
            React.createElement(Button, { variant: 'outlined', color: 'primary', onClick: function () {
                    handleSequenceCallback(false);
                    handleCancelUpdateSequence(editIndex);
                } }, "Discard Sequence"))) : (React.createElement(React.Fragment, null,
            React.createElement(Button, { variant: 'outlined', color: 'primary', onClick: function () {
                    handleUpdateSequence();
                } }, "Update Sequence"),
            React.createElement(Button, { variant: 'outlined', color: 'primary', onClick: function () { return handleCancelUpdateSequence(editIndex); } }, "Cancel")))),
        React.createElement(Dialog, { open: openStudioFlowOverrideAlert, onClose: handleCloseAlert },
            React.createElement(DialogTitle, { id: 'studio-flow-override-warning-title' }, "Studio Flow Override Warning"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: 'studio-flow-override-warning-text' }, "The campaign in use by this schedule has a studio flow override. All studio flow handler values set on sequences will be ignored.")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return setOpenStudioFlowOverrideAlert(false); }, color: 'primary' }, "Confirm"))),
        React.createElement(SnackbarComponent, { anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            }, open: openSnack, autoHideDuration: 5000, onAlertClose: function () { return setOpenSnack(false); }, alertMessage: snackMessage, severity: 'warning' })));
};
Sequence.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=Sequence.js.map